<template>
  <div class="page update-page" :style="{ paddingTop: loginStatus ? '0px' : '' }">
    <Header title='忘记密码' :show-back="true" class="nav" v-if="!loginStatus" />
    <div class="content">

      <van-form @submit="onSubmit" ref="submitForm" :show-error="false">
        <van-field v-model="params.loginAccount" label="手机号" type="tel" placeholder="请输入登录手机号" :rules="rules.mobileRule"
          :readonly="isLoggedIn" />
        <van-field v-model="params.verifyCode" label="验证码" placeholder="验证码"
          :rules="[{ required: true, message: '请输入验证码' }]">
          <template #button>
            <div :style="disableSendBtn ? 'color:grey' : 'color:#00545e'" @click="getVerifyCode">获取验证码{{ countDownText
              }}
            </div>
          </template>
        </van-field>
        <van-field v-model="params.newPassword" label="新密码" type="password" placeholder="请输入新密码" />
        <van-field v-model="params.newPasswordAgain" label="确认新密码" placeholder="请再次输入新密码" type="password" />
        <div class="forget">密码规则：</div>
        <div class="forget1">1. 密码长度为8-12位； </div>
        <div class="forget1">2. 需要包含大写字母、小写字母和数字； </div>
        <div class="forget1">3. 字母和数字不能3位以上连续或重复。</div>
        <div style="margin: 16px;">
          <van-button color="#00545e" block type="info" native-type="submit">重置密码</van-button>
        </div>
      </van-form>
    </div>

    <van-overlay :show="hintOverlay" @click="hintOverlay = false">
      <div class="wrapper-overlay" @click.stop>
        <div class="content-overlay">
          <div class="overlay-cancel" @click="hintOverlay = false">x</div>
          <div class="content-title">修改密码成功,请重新登录账号！</div>
          <div class="overlay-block"></div>
          <div class="overlay-btn" @click="handleLogout()">确定</div>
        </div>
      </div>
    </van-overlay>
    <div class="layer_bg " v-if="layer == 1">

      <div class="layer_d">
        <img src="../../assets/images/JD/layer.png" class="layer_bg_img">
        <div class="layer_pos_bom_btn" @click="layer = 0">确定</div>


      </div>
      <img class="layer_close" @click="layer = 0" src="../../assets/images/JD/btn-close.png">
    </div>

  </div>
</template>

<script>
import validators from '@/utils/validators'
import Header from '@/components/header'
import centerApi from '../../api/center'
import { cryptoUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
export default {
  components: {
    Header
  },
  data() {
    var checkPassword = validators.checkPassword
    var checkMobile = validators.checkMobile
    var checkPasswordAgain = (val) => {
      if (val !== this.params.newPassword) {
        return false
      }
    }
    return {
      layer: 0,
      params: {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: '',
        verifyCode: '',
        loginAccount: ''
      },
      disableSendBtn: false,
      countDownIndex: 0,
      userInfo: {},
      isPassword: '1',
      isForget: '1',
      hintOverlay: false,
      rules: {
        passwordRule: [{ required: true, validator: checkPassword, message: '密码必须由8-12位数字,大小写字母和特殊字符其中三种组成' }],
        passwordAgainRule: [{ required: true, validator: checkPasswordAgain, message: '两次密码输入不一致' }],
        mobileRule: [{ required: true, validator: checkMobile, message: '请输入正确手机号' }]
      },
      isLoggedIn: false,
      loginStatus: false
    }
  },
  computed: {
    countDownText() {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  created() {
    this.loginStatus = this.$route.query.loginStatus
    if (this.loginStatus) {
      this.$dialog.alert({ message: '为了您的账户安全，请修改密码后进行兑换', confirmButtonText: '好的' })
    }
    this.isPassword = this.$route.query.isPassword
    this.isForget = this.$route.query.isForget
    this.userInfo = userUtils.getClientInfo() || {}
    if (this.userInfo.clientUserDTO && this.userInfo.clientUserDTO.userMobile) {
      this.params.mobileNo = this.userInfo.clientUserDTO.userMobile
    }
  },
  methods: {
    changeResetType() {
      this.isPassword = '0'
      this.$refs.submitForm.resetValidation()
    },
    getVerifyCode() {
      if (this.params.loginAccount === '' || !validators.checkMobile(this.params.loginAccount)) {
        this.$toast('请输入正确手机号！')
        return
      }
      if (this.disableSendBtn) {
        return
      }
      let params = {
        mobileNo: this.params.loginAccount
      }
      centerApi.publicResetPasswordVerifyCode(params).then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown() {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    onSubmit() {
      var that = this
      var re = /^[0-9a-zA-Z]{8,12}$/
      if (!re.test(that.params.newPassword)) {
        that.params.newPasswordAgain = ''
        that.params.newPassword = ''
        this.layer = 1
        return
      }
      if (this.params.newPasswordAgain !== this.params.newPassword) {
        this.$toast('两次密码输入不一致')
        return false
      }
      let params = {}
      params = {
        newPassword: cryptoUtils.AESEncrypt(this.params.newPassword),
        verifyCode: this.params.verifyCode,
        loginAccount: this.params.loginAccount
      }
      centerApi.publicResetPassword(params).then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData && res.data.resultData.errorType == 1) {
            that.params.newPasswordAgain = ''
            that.params.newPassword = ''
            that.layer = 1
            return false
          }
          this.hintOverlay = true
          userUtils.removeUserLocal()
        }
      })
    },
    handleLogout() {
      if (localStorage.getItem('oldfullPath')) {
        this.$router.push({ name: 'login2' })
      } else {
        this.$router.push({ name: 'home-main' })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.forget {
  margin-left: 10px;
  width: 100%;
  font-size: 14px;
  text-align: left;
  margin-top: 20px;
  color: #EB5336;
  margin-bottom: 8px;
}

.forget1 {
  margin-left: 10px;
  width: 100%;
  text-align: left;
  color: #EB5336;
  font-size: 12px;
  line-height: 20px;
  /* 158.333% */
}

.register-field {
  margin: 20px 15px;

  .register-field-title {
    font-weight: bolder;
    font-size: 16px;
  }
}

.field-btn {
  position: absolute;
  right: 15px;
  line-height: 40px;
  color: #00545e
}

.notice-bar {
  display: flex;
  background-color: rgb(238, 236, 203);
  padding: 6px 10px;
  color: rgb(182, 157, 16);
  margin: 15px;
  width: calc(100% - 50px);
  border-radius: 5px;
  justify-content: space-between;
}

.upload-icon {

  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: dashed 2px rgb(190, 190, 190);
  font-size: 30px;
  text-align: center;
  color: rgb(190, 190, 190);
}

.van-uploader {
  margin-top: 15px;
}

.wrapper-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.content-overlay {
  background-image: url('../dialog-bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  width: 80%;
  background-color: #fff;
  border-radius: 14px;

  img {
    width: 100%;
  }

  .overlay-cancel {
    color: #fff;
    font-size: 80px;
    position: absolute;
    right: 0px;
  }

  .content-title {
    font-size: 19px;
    text-align: center;
    color: white;
    margin: 25px 0 15px 0;
  }

  .content-info {
    background-color: rgb(255, 255, 255);
    width: 86%;
    margin-left: 7%;
    z-index: 10;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    box-shadow: 0px 0px 0px 0px #f1f1f1,
      0px 0px 2px 0px #f1f1f1,
      0px 0px 2px 0px #f1f1f1,
      0px 2px 13px 0px #f1f1f1;

    .overlay-icon {
      padding-top: 20px;
    }
  }

  .overlay-btn {
    text-align: center;
    font-size: 18px;
    color: var(--base-green);
    padding: 15px 0 20px 0;
  }

  .content-info-client {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    text-align: left !important;
    color: var(--base-green);
    font-size: 14px;
    padding-left: 10px;
  }

  .content-info-client-name {
    font-weight: 600;
  }

  .content-info-client-right {
    font-size: 14px;
    line-height: 18px !important;
    padding: 15px 10px 0 0;
  }

  .content-info-client-code {
    font-size: 12px;
  }
}
</style>
